<div class="container">
    <h1>Please enter SSH Userame and Password</h1>
    @if (address==null){
    <h3>Connecting to IP {{address}}</h3>
    }
    <div class="inputs">
        <mat-form-field>
            <mat-label>Username: </mat-label>
            <input matInput placeholder="Username" [formControl]="username">
            @if (username.errors && username.hasError('required')) {
            <mat-error>
                <span>Username is required</span>
            </mat-error>
            }
        </mat-form-field>
        <mat-form-field>
            <mat-label>Password: </mat-label>

            <input matInput placeholder="Password" [formControl]="password" type="password">
        </mat-form-field>
    </div>
    <div class="buttons">
        <button mat-raised-button (click)="closeDialog(true)"><mat-icon>login</mat-icon>Log In</button>
        <button mat-raised-button (click)="closeDialog(false)">Close</button>
    </div>
</div>